import { render, staticRenderFns } from "./LegalAgreement.vue?vue&type=template&id=6bc6c3b2&scoped=true&"
import script from "./LegalAgreement.vue?vue&type=script&lang=js&"
export * from "./LegalAgreement.vue?vue&type=script&lang=js&"
import style0 from "./LegalAgreement.vue?vue&type=style&index=0&id=6bc6c3b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6c3b2",
  null
  
)

export default component.exports